import { Ambiente } from 'app/use-cases/orcamento/ambiente/Ambiente';
import React, { useEffect, useRef, useState } from 'react';
import { AmbienteItem } from './AmbienteItem';
import {  MenuDeAmbientes } from './MenuDeAmbientes';

export type AmbienteItemComMenuProps = {
    ambientes: Ambiente[],
    proximaCor: string,
    onSalvarNovoAmbiente: (ambiente: Ambiente) => void
    onAmbienteSelecionado: (ambiente: Ambiente) => void
    onAmbienteRemovido: (ambiente: Ambiente) => void
    ambiente: Ambiente
    toggleLimparNovoAmbiente:string
    onMenuAmbientesAberto: (larguraContainer: number) => void
    onExibicaoMenuAlterada?: (exibindo: boolean) => void
    onMouseSobreMenu?: (sobre: boolean) => void
}



export const AmbienteItemComMenu = (props: AmbienteItemComMenuProps) => {
    const [exibirDefinirAmbiente,setExibirDefinirAmbiente] = useState(false)

    const definirExibicaoMenu = (exibindo: boolean) => {
        setExibirDefinirAmbiente(exibindo)
        props.onExibicaoMenuAlterada?.(exibindo)
        if (!exibindo) props.onMouseSobreMenu?.(false)
    }

    return <>
        <div>
            <AmbienteItem
                cor={props.ambiente.cor}
                nome={props.ambiente.nome}
                onSelecionado={() => {
                    const novoValorExibirDefinirAmbiente = !exibirDefinirAmbiente
                    definirExibicaoMenu(novoValorExibirDefinirAmbiente)
                    if (novoValorExibirDefinirAmbiente) {
                        props.onMenuAmbientesAberto(208)
                    }
                }}
                />
        

            <MenuDeAmbientes 
                exibir={exibirDefinirAmbiente}
                ambientes={props.ambientes}
                proximaCor={props.proximaCor}
                onSalvarNovoAmbiente={ambiente => {
                    props.onSalvarNovoAmbiente(ambiente)
                    definirExibicaoMenu(false)
                }}
                onAmbienteSelecionado={ambiente => {
                    props.onAmbienteSelecionado(ambiente)
                    definirExibicaoMenu(false)
                }}
                onCancelar={() => definirExibicaoMenu(false)}
                onAmbienteRemovido={ambiente => {
                    props.onAmbienteRemovido(ambiente)
                    definirExibicaoMenu(false)
                }}
                toggleLimparNovoAmbiente={props.toggleLimparNovoAmbiente}
                onMouseSobreMenu={props.onMouseSobreMenu}/>
        </div>
    </>
}